import { assertInteger, DomainError } from "../errors.js";
import { multiplyMoney, sumMoney } from "../money/index.js";
/**
 * A per-PC add-on's monthly charge: `quantity × unitPrice`, exact, in the unit price's currency. The quantity is a
 * whole number of PCs and never negative (zero is allowed here, for a preview of an empty field; the api refuses an
 * add-on for no PCs).
 */
export function addonMonthlyCharge(unitPrice, quantity) {
    assertInteger(quantity, 'quantity');
    if (quantity < 0) {
        throw new DomainError('out-of-range', `An add-on licenses a whole number of PCs, not ${quantity}.`, { quantity });
    }
    if (unitPrice.amount < 0) {
        throw new DomainError('out-of-range', 'An add-on’s unit price is never negative.', { amount: unitPrice.amount });
    }
    return multiplyMoney(unitPrice, quantity);
}
/**
 * The monthly total of the active add-ons' charges, in `currency` — the organisation's, which is also the total when
 * none is active. A charge in another currency throws rather than being added (spec/06 §1.2).
 */
export function addonsMonthlyTotal(charges, currency) {
    return sumMoney(charges, currency);
}
/**
 * What each add-on grants (ADR-0063 decision 13). Code, not data: the catalogue prices and offers an add-on, a release
 * decides what it unlocks.
 */
export const ADDON_GRANTS = {
    boot: { switches: ['boot'], quantityLimit: 'maxBootPcs' },
};
/**
 * The entitlements the active add-ons grant: `boot` with an active `boot` add-on, and `maxBootPcs` its quantity.
 * Nothing active grants nothing — the empty set every organisation held before add-ons existed.
 */
export function entitlementsFromAddons(active) {
    const granted = new Set();
    const limits = {};
    for (const addon of active) {
        assertInteger(addon.quantity, 'quantity');
        const grant = ADDON_GRANTS[addon.key];
        for (const key of grant.switches)
            granted.add(key);
        if (grant.quantityLimit !== null) {
            granted.add(grant.quantityLimit);
            limits[grant.quantityLimit] = (limits[grant.quantityLimit] ?? 0) + addon.quantity;
        }
    }
    return { granted, limits };
}
//# sourceMappingURL=index.js.map